/**
 * @file       Index.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import Vue from "vue";
import Vuex from "vuex";

import auth from "@/modules/auth/store";
import admin from "@/modules/admin/store";
import teachers from "@/modules/teachers/store";
import students from "@/modules/students/store";
import deliberations from "@/modules/deliberations/store";
import home from "@/modules/home/store";
import messages from "@/modules/messages/store";
import groups from "@/modules/groups/store";
import grid from "@/modules/grid/store";
import comments from "@/modules/comments/store";
import blackWord from "@/modules/blackWord/store";
import files from "@/modules/files/store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    admin,
    teachers,
    students,
    deliberations,
    home,
    messages,
    groups,
    grid,
    comments,
    blackWord,
    files
  },
  strict: true
});
